module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm_head"
  }, [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Battleground Series")])])]), _c('a', {
    attrs: {
      "id": "page_ii"
    }
  }, [_c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Stamford Bridge & Hastings")]), _vm._v(" by Peter Marren")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Wars of the Roses - Wakefield/Towton")]), _vm._v(" by Philip A. Haigh")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Wars of the Roses - Barnet")]), _vm._v(" by David Clark")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Wars of the Roses - Tewkesbury")]), _vm._v(" by Steven Goodchild")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Wars of the Roses - The Battles of St Albans")]), _vm._v(" by Peter Burley, Michael Elliott & Harvey Wilson")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("English Civil War - Naseby")]), _vm._v(" by Martin Marix Evans, Peter Burton and Michael Westaway")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("English Civil War - Marston Moor")]), _vm._v(" by David Clark")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("War of the Spanish Succession - Blenheim 1704")]), _vm._v(" by James Falkner")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("War of the Spanish Succession - Ramillies 1706")]), _vm._v(" by James Falkner")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Napoleonic - Hougoumont")]), _vm._v(" by Julian Paget and Derek Saunders")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Napoleonic - Waterloo")]), _vm._v(" by Andrew Uffindell and Michael Corum")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Zulu War - Isandlwana")]), _vm._v(" by Ian Knight and Ian Castle")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Zulu War - Rorkes Drift")]), _vm._v(" by Ian Knight and Ian Castle")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Boer War - The Relief of Ladysmith")]), _vm._v(" by Lewis Childs")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Boer War - The Siege of Ladysmith")]), _vm._v(" by Lewis Childs")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Boer War - Kimberley")]), _vm._v(" by Lewis Childs")]), _vm._v(" "), _c('p', {
    staticClass: "centerf1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Mons")]), _vm._v(" by Jack Horsfall and Nigel Cave")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Néry")]), _vm._v(" by Patrick Tackle")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Retreat of I Corps 1914")]), _vm._v(" by Jerry Murland")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Aisne 1914")]), _vm._v(" by Jerry Murland")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Aisne 1918")]), _vm._v(" by David Blanchard")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Le Cateau")]), _vm._v(" by Nigel Cave and Jack Shelden")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Walking the Salient")]), _vm._v(" by Paul Reed")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Ypres - 1914 Messines")]), _vm._v(" by Nigel Cave and Jack Sheldon")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Ypres - 1914 Menin Road")]), _vm._v(" by Nigel Cave and Jack Sheldon")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Ypres - 1914 Langemarck")]), _vm._v(" by Jack Sheldonand Nigel Cave")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Ypres - Sanctuary Wood and Hooge")]), _vm._v(" by Nigel Cave")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Ypres - Hill 60")]), _vm._v(" by Nigel Cave")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Ypres - Messines Ridge")]), _vm._v(" by Peter Oldham")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Ypres - Polygon Wood")]), _vm._v(" by Nigel Cave")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Ypres - Passchendaele")]), _vm._v(" by Nigel Cave")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Ypres - Airfields and Airmen")]), _vm._v(" by Mike O’Connor")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Ypres - St Julien")]), _vm._v(" by Graham Keech")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Ypres - Boesinghe")]), _vm._v(" by Stephen McGreal")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Walking the Somme")]), _vm._v(" by Paul Reed")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Somme - Gommecourt")]), _vm._v(" by Nigel Cave")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Somme - Serre")]), _vm._v(" by Jack Horsfall & Nigel Cave")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Somme - Beaumont Hamel")]), _vm._v(" by Nigel Cave")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Somme - Thiepval")]), _vm._v(" by Michael Stedman")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Somme - La Boisselle")]), _vm._v(" by Michael Stedman")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Somme - Fricourt")]), _vm._v(" by Michael Stedman")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Somme - Carnoy-Montauban")]), _vm._v(" by Graham Maddocks")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Somme - Pozières")]), _vm._v(" by Graham Keech")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Somme - Courcelette")]), _vm._v(" by Paul Reed")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Somme - Boom Ravine")]), _vm._v(" by Trevor Pidgeon")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Somme - Mametz Wood")]), _vm._v(" by Michael Renshaw")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Somme - Delville Wood")]), _vm._v(" by Nigel Cave")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Somme - Advance to Victory (North) 1918")]), _vm._v(" by Michael Stedman")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Somme - Flers")]), _vm._v(" by Trevor Pidgeon")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Somme - Bazentin Ridge")]), _vm._v(" by Edward Hancock")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Somme - Combles")]), _vm._v(" by Paul Reed")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Somme - Beaucourt")]), _vm._v(" by Michael Renshaw")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Somme - Redan Ridge")]), _vm._v(" by Michael Renshaw")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Somme - Hamel")]), _vm._v(" by Peter Pedersen")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Somme - Villers-Bretonneux")]), _vm._v(" by Peter Pedersen")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Somme - Airfields and Airmen")]), _vm._v(" by Mike O’Connor")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Airfields and Airmen of the Channel Coast")]), _vm._v(" by Mike O’Connor")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("In the Footsteps of the Red Baron")]), _vm._v(" by Mike O’Connor")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Arras - Airfields and Airmen")]), _vm._v(" by Mike O’Connor")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Arras - The Battle for Vimy Ridge")]), _vm._v(" by Jack Sheldon & Nigel Cave")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Arras - Vimy Ridge")]), _vm._v(" by Nigel Cave")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Arras - Gavrelle")]), _vm._v(" by Trevor Tasker and Kyle Tallett")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Arras - Oppy Wood")]), _vm._v(" by David Bilton")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Arras - Bullecourt")]), _vm._v(" by Graham Keech")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Arras - Monchy le Preux")]), _vm._v(" by Colin Fox")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Walking Arras")]), _vm._v(" by Paul Reed")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Hindenburg Line")]), _vm._v(" by Peter Oldham")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Hindenburg Line - Epehy")]), _vm._v(" by Bill Mitchinson")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Hindenburg Line - Riqueval")]), _vm._v(" by Bill Mitchinson")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Hindenburg Line - Villers-Plouich")]), _vm._v(" by Bill Mitchinson")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Hindenburg Line - Cambrai Right Hook")]), _vm._v(" by Jack Horsfall & Nigel Cave")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Hindenburg Line - Cambrai Flesquières")]), _vm._v(" by Jack Horsfall & Nigel Cave")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Hindenburg Line - Saint Quentin")]), _vm._v(" by Helen McPhail and Philip Guest")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Hindenburg Line - Bourlon Wood")]), _vm._v(" by Jack Horsfall & Nigel Cave")]), _vm._v(" "), _c('p', {
    staticClass: "centerf1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Cambrai - Airfields and Airmen")]), _vm._v(" by Mike O’Connor")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Aubers Ridge")]), _vm._v(" by Edward Hancock")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("La Bassée - Neuve Chapelle")]), _vm._v(" by Geoffrey Bridger")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Loos - Hohenzollern Redoubt")]), _vm._v(" by Andrew Rawson")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Loos - Hill 70")]), _vm._v(" by Andrew Rawson")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Fromelles")]), _vm._v(" by Peter Pedersen")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("The Battle of the Lys 1918")]), _vm._v(" by Phil Tomaselli")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Accrington Pals Trail")]), _vm._v(" by William Turner")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Poets at War: Wilfred Owen")]), _vm._v(" by Helen McPhail and Philip Guest")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Poets at War: Edmund Blunden")]), _vm._v(" by Helen McPhail and Philip Guest")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Poets at War: Graves & Sassoon")]), _vm._v(" by Helen McPhail and Philip Guest")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Gallipoli")]), _vm._v(" by Nigel Steel")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Gallipoli - Gully Ravine")]), _vm._v(" by Stephen Chambers")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Gallipoli - Anzac Landing")]), _vm._v(" by Stephen Chambers")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Gallipoli - Suvla August Offensive")]), _vm._v(" by Stephen Chambers")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Gallipoli - Landings at Helles")]), _vm._v(" by Huw & Jill Rodge")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Walking Gallipoli")]), _vm._v(" by Stephen Chambers")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Walking the Italian Front")]), _vm._v(" by Francis Mackay")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Italy - Asiago")]), _vm._v(" by Francis Mackay")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Verdun: Fort Douamont")]), _vm._v(" by Christina Holstein")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Verdun: Fort Vaux")]), _vm._v(" by Christina Holstein")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Walking Verdun")]), _vm._v(" by Christina Holstein")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Verdun: The Left Bank")]), _vm._v(" by Christina Holstein")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Zeebrugge & Ostend Raids 1918")]), _vm._v(" by Stephen McGreal")]), _vm._v(" "), _c('p', {
    staticClass: "centerf_linet"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Germans at Beaumont Hamel")]), _vm._v(" by Jack Sheldon")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Germans at Thiepval")]), _vm._v(" by Jack Sheldon")]), _vm._v(" "), _c('p', {
    staticClass: "centerf_linetb"
  }), _vm._v(" "), _c('p', {
    staticClass: "centerf1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("SECOND WORLD WAR")])]), _vm._v(" "), _c('p', {
    staticClass: "centerf1a"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Dunkirk")]), _vm._v(" by Patrick Wilson")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Calais")]), _vm._v(" by Jon Cooksey")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Boulogne")]), _vm._v(" by Jon Cooksey")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Saint-Nazaire")]), _vm._v(" by James Dorrian")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Walking D-Day")]), _vm._v(" by Paul Reed")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Atlantic Wall - Pas de Calais")]), _vm._v(" by Paul Williams")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Atlantic Wall - Normandy")]), _vm._v(" by Paul Williams")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Normandy - Pegasus Bridge")]), _vm._v(" by Carl Shilleto")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Normandy - Merville Battery")]), _vm._v(" by Carl Shilleto")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Normandy - Utah Beach")]), _vm._v(" by Carl Shilleto")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Normandy - Omaha Beach")]), _vm._v(" by Tim Kilvert-Jones")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Normandy - Gold Beach")]), _vm._v(" by Christopher Dunphie & Garry Johnson")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Normandy - Gold Beach Jig")]), _vm._v(" by Tim Saunders")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Normandy - Juno Beach")]), _vm._v(" by Tim Saunders")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Normandy - Sword Beach")]), _vm._v(" by Tim Kilvert-Jones")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Normandy - Operation Bluecoat")]), _vm._v(" by Ian Daglish")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Normandy - Operation Goodwood")]), _vm._v(" by Ian Daglish")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Normandy - Epsom")]), _vm._v(" by Tim Saunders")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Normandy - Hill 112")]), _vm._v(" by Tim Saunders")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Normandy - Mont Pinçon")]), _vm._v(" by Eric Hunt")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Normandy - Cherbourg")]), _vm._v(" by Andrew Rawson")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Normandy - Commandos & Rangers on D-Day")]), _vm._v(" by Tim Saunders")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Das Reich – Drive to Normandy")]), _vm._v(" by Philip Vickers")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Oradour")]), _vm._v(" by Philip Beck")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Market Garden - Nijmegen")]), _vm._v(" by Tim Saunders")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Market Garden - Hell’s Highway")]), _vm._v(" by Tim Saunders")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Market Garden - Arnhem, Oosterbeek")]), _vm._v(" by Frank Steer")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Market Garden - Arnhem, The Bridge")]), _vm._v(" by Frank Steer")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Market Garden - The Island")]), _vm._v(" by Tim Saunders")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Rhine Crossing – US 9th Army & 17th US Airborne")]), _vm._v(" by Andrew Rawson")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("British Rhine Crossing – Operation Varsity")]), _vm._v(" by Tim Saunders")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("British Rhine Crossing – Operation Plunder")]), _vm._v(" by Tim Saunders")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Battle of the Bulge – St Vith")]), _vm._v(" by Michael Tolhurst")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Battle of the Bulge – Bastogne")]), _vm._v(" by Michael Tolhurst")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Channel Islands")]), _vm._v(" by George Forty")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Walcheren")]), _vm._v(" by Andrew Rawson")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Remagen Bridge")]), _vm._v(" by Andrew Rawson")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Cassino")]), _vm._v(" by Ian Blackwell")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Anzio")]), _vm._v(" by Ian Blackwell")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Dieppe")]), _vm._v(" by Tim Saunders")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Fort Eben Emael")]), _vm._v(" by Tim Saunders")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Crete – The Airborne Invasion")]), _vm._v(" by Tim Saunders")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Malta")]), _vm._v(" by Paul Williams")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Bruneval Raid")]), _vm._v(" by Paul Oldfield")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Cockleshell Raid")]), _vm._v(" by Paul Oldfield")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b15d0a76","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/02_Frontmatter_01.vue
// module id = 60
// module chunks = 0